"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CookiesContext = react_1.default.createContext({
    cookies: {},
});
exports.default = CookiesContext;
//# sourceMappingURL=CookiesContext.js.map